// Safari Browser Control
// ------------------------------------------------------------------
let isSafari = navigator.vendor.match(/apple/i) &&
    !navigator.userAgent.match(/crios/i) &&
    !navigator.userAgent.match(/fxios/i) &&
    !navigator.userAgent.match(/Opera|OPT\//)
if (isSafari) body.addClass('is-safari')

// FancyBox
// ------------------------------------------------------------------
import { Fancybox } from '@fancyapps/ui'
window.Fancybox = Fancybox

// FancyBox Settings
// ------------------------------------------------------------------
Fancybox.defaults.placeFocusBack = 0;
Fancybox.defaults.autoFocus = false;
Fancybox.defaults.trapFocus = false;
Fancybox.defaults.dragToClose = false;

Fancybox.bind("[data-fancybox]", {
    infinite: false,
    Toolbar: {
        display: [
            // Aşağıda bulunan yorum satırları kaldırarak butonların görünmesini sağlayabilirsiniz.
            // { id: "prev", position: "center" }, // Page Top Prev Disabled
            // { id: "counter", position: "center" }, // Page Top Counter Disabled
            // { id: "next", position: "center" }, // Page Top Next Disabled
            // "zoom", // Zoom Disabled
            // "slideshow", // Slide Show Disabled
            // "fullscreen", // Full Screen Disabled
            // "thumbs", // Thumbs Disabled
            "download", // Download Enabled
            "close", // Close Enabled
        ],
    },
})

// Smart Menu
// ------------------------------------------------------------------
let currentScrollTop = $(window).scrollTop();
if (currentScrollTop >= 50) { header.addClass('hidden'); header.addClass('is-fixed'); }
else { header.removeClass('hidden'); header.removeClass('is-fixed'); }

let lastScrollTop = 0;
let stickyObject = $('.sticky');
$(window).scroll(function () {
    var scrollTop = $(this).scrollTop();
    if (scrollTop > lastScrollTop) {
        stickyObject.css('top', '45px');
        if (scrollTop > 50) { header.addClass('hidden'); header.addClass('is-fixed'); }
    } else {
        if (!header.hasClass('no-scroll')) {
            stickyObject.css('top', header.height() + 45)
        }

        if (scrollTop > 50) { header.removeClass('hidden'); header.addClass('is-fixed'); }
        else { header.removeClass('hidden'); header.removeClass('is-fixed'); }
    }
    lastScrollTop = scrollTop;
});

// Tel Input Only Number Fix
// ------------------------------------------------------------------
function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value
                this.oldSelectionStart = this.selectionStart
                this.oldSelectionEnd = this.selectionEnd
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd)
            } else {
                this.value = ""
            }
        })
    })
}
const telInputs = document.querySelectorAll('input[type="tel"]')
telInputs.forEach(function (input) {
    setInputFilter(input, function (value) {
        return /^\d*\+?\d*$/.test(value)
    })
})

// Accordion
// ------------------------------------------------------------------
const slideDown = elem => { elem.style.marginBottom = `30px`; elem.style.height = `${elem.scrollHeight + 30}px`; }
const slideUp = elem => { elem.style.marginBottom = `0px`; elem.style.height = `0px`; }

let accordions = document.querySelectorAll('.accordion');
accordions.forEach((element, index) => {
    element.querySelector('.shown').addEventListener('click', () => {
        let classes = element.querySelector('.shown').parentNode.getAttribute('class')
        if (!classes.includes('active')) {
            element.classList.add('active')
            slideDown(element.querySelector('.hidden'));
        }
        else {
            element.classList.remove('active')
            slideUp(element.querySelector('.hidden'));
        }
    });

    let classes = element.querySelector('.shown').parentNode.getAttribute('class')
    if (classes.includes('active')) slideDown(element.querySelector('.hidden'));
});

// Find Middle Child
// ------------------------------------------------------------------
window.findMiddleObject = function (arr, middleBeforeClass, middleAfterClass, middleClass) {
    if (arr.length % 2 == 0) {
        middleBefore = arr[Math.floor((arr.length - 1) / 2)];
        middleAfter = arr[Math.ceil((arr.length - 1) / 2)];

        middleBefore.classList.add(middleBeforeClass)
        middleAfter.classList.add(middleAfterClass)
    }
    else {
        middle = arr[Math.round((arr.length - 1) / 2)];
        middle.classList.add(middleClass)
    }
}

// SCROLL CLICK ANIMATION
// ------------------------------------------------------------------
if ($('.scroll-animation').length) {
    $(".scroll-animation").on('click', function () {
        let target = $(this).attr('data-target')
        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 1000)
        $(".scroll-animation").removeClass("active")
        $(this).addClass("active")
    })
}

// SCROLL CLICK ANIMATION - MOBILE
// ------------------------------------------------------------------
if ($('.scroll-animation-mobile').length) {
    if (windowWidth <= 768) {
        $(".scroll-animation-mobile").on('click', function () {
            let target = $(this).attr('data-target')
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 1000)
            $(".scroll-animation").removeClass("active")
            $(this).addClass("active")
        })
    }
}

// Dynamic Height Change For Class
// ------------------------------------------------------------------
if ($('.height-dynamic-viewport').length) {
    $('.height-dynamic-viewport').height($(window).height())
    $(window).resize(function () {
        if ($('.height-dynamic-viewport').length) $('.height-dynamic-viewport').height($(window).height())
    })
}

// Dynamic Height Change For Class - Header Height
// ------------------------------------------------------------------
if ($('.height-dynamic-viewport-header').length) {
    let headerHeight = $('header').height()
    $('.height-dynamic-viewport-header').height($(window).height() - headerHeight - 60)
    $(window).resize(function () {
        if ($('.height-dynamic-viewport-header').length) {
            $('.height-dynamic-viewport-header').height($(window).height() - headerHeight - 60)
        }
    })
}

// FORM ITEM - LABEL CHECK
// ------------------------------------------------------------------
if ($('.form .item').length) {
    $.each($('.form .item'), function () {
        $(this).find('label').closest('.item').addClass('with-label')
    })
}

// JQUERY PRINT
// ------------------------------------------------------------------
import printThis from 'print-this'

// BLOG CONTROLLER
// ------------------------------------------------------------
if ($('.blog-controller').length) {
    // Blog Font Size Change
    var blog_size = 0
    $('.blog-controller .blog-size').click(function () {
        blog_size++

        if (blog_size > 3) blog_size = 0

        if (blog_size == 0) {
            $(this).closest('.single-blog').find('.editor').find('p').css('font-size', '1.125rem')
        }
        if (blog_size == 0) {
            $(this).closest('.single-blog').find('.editor').find('li').css('font-size', '1.125rem')
        }
        if (blog_size == 1) {
            $(this).closest('.single-blog').find('.editor').find('p').css('font-size', '1.25rem')
        }
        if (blog_size == 1) {
            $(this).closest('.single-blog').find('.editor').find('li').css('font-size', '1.25rem')
        }
        if (blog_size == 2) {
            $(this).closest('.single-blog').find('.editor').find('p').css('font-size', '1.5rem')
        }
        if (blog_size == 2) {
            $(this).closest('.single-blog').find('.editor').find('li').css('font-size', '1.5rem')
        }
        if (blog_size == 3) {
            $(this).closest('.single-blog').find('.editor').find('p').css('font-size', '1.75rem')
        }
        if (blog_size == 3) {
            $(this).closest('.single-blog').find('.editor').find('li').css('font-size', '1.75rem')
        }
    })
    // Blog Print
    $('.blog-controller .blog-print').click(function () {
        $('.editor-field .editor').printThis()
    })
    // Blog URL Copy
    var copy_interval
    var $url = $(location).attr('href')
    var $temp = $("<input>")
    $('.blog-controller .blog-url').click(function () {
        $(this).css('pointer-events', 'hidden')
        $(this).addClass('copied')
        $('body').append($temp)
        $temp.val($url).select()
        document.execCommand("copy")
        $temp.remove()
        clearInterval(copy_interval)
        copy_interval = setInterval(() => {
            $(this).css('pointer-events', 'unset')
            $(this).removeClass('copied')
        }, 1000)
    })

    var copy_interval
    var $url = $(location).attr('href')
    var $temp = $("<input>")
    $('.blog-controller .link').click(function () {
        $(this).css('pointer-events', 'hidden')
        $(this).addClass('copied')
        $('body').append($temp)
        $temp.val($url).select()
        document.execCommand("copy")
        $temp.remove()
        clearInterval(copy_interval)
        copy_interval = setInterval(() => {
            $(this).css('pointer-events', 'unset')
            $(this).removeClass('copied')
        }, 1000)
    })
}